module.exports = __webpack_public_path__ + "static/media/icon_plan_name.02770b0e.svg";